import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";
import { Auth } from "aws-amplify";
import { updateSurveyFromAPI } from "../../../services/surveyService";
import { setCurrentSurvey, updateTabStates } from "../../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import Button from "../../layout/button";
export default function CollectImportRecipientList() {
  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
  const [newUsers, setNewUsers] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [sortedData, setSortedData] = useState([]);
  let [token, setToken] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [fileUploadInfoMenu, setFileUploadInfoMenuShow] = useState(false)
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false)
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedFunctionParam, setSelectedFunctionParam] = useState("");

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }
  useEffect(() => {
    if (token.length > 0) {
      if (selectedFunction === "updateSurveyUserList") {
        updateSurveyUserList();
      }
      setSelectedFunction("");
    }
  }, [token]);

  function handleFileChange(event) {
    const file = event.target.files[0];
    const fileName = file.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (fileExtension === "csv") {
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = function () {
        const csvContent = reader.result;
        const rows = csvContent.split("\r").map((row) =>
          row
            .trim()
            .split(",")
            .map((cell) => cell.trim())
        );

        // İlk satırı header olarak ayırıyoruz
        const header = rows[0];
        const dataRows = rows
          .slice(1)
          .filter((row) => row.length && row[0] !== "");
        const data = dataRows.map((row) => {
          let rowData = {};
          row.forEach((value, index) => {
            const key = header[index];
            rowData[key] = value;
          });
          return rowData;
        });
        let _newUsers = [];
        data.forEach((item) => {
          _newUsers.push({
            user_id: uuidv4(),
            first_name: item["First Name"],
            last_name: item["Last Name"],
            email: item["Email"],
            organization_name: currentSurvey.organization,
          });
        });
        const new_users = [
          ..._newUsers,
          ...currentSurvey.survey_users.filter(
            (user) => !_newUsers.map((us) => us.email).includes(user.email)
          ),
        ];
        setNewUsers(new_users);
        setShowTable(true);
        updateSurveyUserList(new_users);
      };
    } else if (fileExtension === "xlsx" || fileExtension === "xls") {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // İlk sayfayı alıyoruz
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Sayfayı JSON formatına çeviriyoruz
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // İlk satırı header olarak ayırıyoruz
        const header = rows[0];
        const dataRows = rows
          .slice(1)
          .filter((row) => row.length && row[0] !== ""); // Boş satırları filtreliyoruz

        // Header ile dataRows'u key-value nesne yapısına çeviriyoruz
        const excel_data = dataRows.map((row) => {
          let rowData = {};
          row.forEach((value, index) => {
            const key = header[index];
            rowData[key] = value;
          });
          return rowData;
        });

        let _newUsers = [];
        excel_data.forEach((item) => {
          _newUsers.push({
            user_id: uuidv4(),
            first_name: item["First Name"],
            last_name: item["Last Name"],
            email: item["Email"],
            organization_name: currentSurvey.organization,
          });
        });
        const new_users = [
          ..._newUsers,
          ...currentSurvey.survey_users.filter(
            (user) => !_newUsers.map((us) => us.email).includes(user.email)
          ),
        ];
        setNewUsers(new_users);
        setShowTable(true);
        updateSurveyUserList(new_users);
      };

      reader.readAsArrayBuffer(file);
    }
  }

  async function updateSurveyUserList(new_users) {
    const obj = {
      survey_users: new_users,
    };
    await updateSurveyFromAPI(token, obj, currentSurvey.ID)
      .then((result) => {
        let _newCurrentSurvey = { ...currentSurvey };
        _newCurrentSurvey.survey_users = new_users;
        // dispatch(setCurrentSurvey(_newCurrentSurvey));
        dispatch(
          updateTabStates(
            topMenuTabs.activeTab,
            "currentSurvey",
            _newCurrentSurvey
          )
        );
        setSuccess(true);
        setError(false);
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          setSelectedFunction("updateSurveyUserList");
          setSelectedFunctionParam(new_users);
          checkAuth();
        } else {
          setSuccess(false);
          setError(true);
        }
      });
    setFileUploadInfoMenuShow(true);
  }

function downloadTemplate(type) {
  if (type === "excel") {
    fetch("/assets/excel/add_recipientList_template.xlsx")
      .then(res => {
        if (!res.ok) throw new Error("Excel file not found");
        return res.blob();
      })
     .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "new_user.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  } else if (type === "csv") {
    fetch("/assets/csv/add_recipientList_template.csv")
      .then(res => {
        if (!res.ok) throw new Error("CSV file not found");
        return res.text();
      })
      .then(text => {
        const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "new_users.csv";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(
        // err => console.error(err)
      );
  }
}

  //   useEffect(() => {
  //     const filtered = newUsers.filter((row) =>
  //       row.first_name.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //     setFilteredData(filtered);
  //   }, [data, searchTerm]);

  // İleri düzey filtreleme
  //   useEffect(() => {
  //     const filteredSearch = newUsers.filter((row) => {
  //         console.log(row)
  //       if (!selectedLabel || !filterSearchTerm) return true; // Eğer filtre seçilmemişse tüm veriyi göster
  //       if (selectedLabel.toLowerCase()==="name"){
  //         const fullName = (row.first_name + " " + row.last_name).toLowerCase();
  //         return fullName.includes(filterSearchTerm.toLowerCase());
  //       }
  //       else if (selectedLabel.toLowerCase()==="organization"){
  //         const organization = (row.organization_name).toLowerCase();
  //         return organization.includes(filterSearchTerm.toLowerCase());
  //       }
  //       else{
  //       return row[selectedLabel.toLowerCase()]
  //         ?.toLowerCase()
  //         .includes(filterSearchTerm.toLowerCase()); // Seçilen label ve arama terimine göre filtreleme
  //       }
  //     });
  //     setFilteredSearchData(filteredSearch);
  //   }, [filteredData, selectedLabel, filterSearchTerm]);
  useEffect(() => {
    if (sortConfig.key) {
      const sorted = [...newUsers].sort((a, b) => {
        // Sayılar ve metinler için karşılaştırmayı türüne göre yap
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];
        if (sortConfig.key === "name") {
          valA = a.first_name + " " + a.last_name;
          valB = b.first_name + " " + b.last_name;
        }

        // Verinin türüne göre karşılaştırma yap
        if (typeof valA === "string" && typeof valB === "string") {
          // String karşılaştırması (case-insensitive)
          const aLower = valA.toLowerCase();
          const bLower = valB.toLowerCase();

          if (aLower < bLower) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aLower > bLower) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        } else if (typeof valA === "number" && typeof valB === "number") {
          // Sayısal karşılaştırma
          if (valA < valB) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (valA > valB) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        }
        return 0;
      });
      setSortedData(sorted);
    } else {
      setSortedData(newUsers);
    }
  }, [sortConfig]);

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };
  useEffect(() => {
    // Automatically close the dialog after 5 seconds
    const timer = setTimeout(() => {
      setFileUploadInfoMenuShow(false);
    }, 3000); // 5000 ms = 5 seconds

    // Cleanup the timer when the component unmounts or dialog closes
    return () => clearTimeout(timer);
  }, [fileUploadInfoMenu, setFileUploadInfoMenuShow]);
  return (
    <div
      className={` flex flex-col gap-4 p-4 pl-4 sm:pl-12  mt-4 ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#fbfbfc]"
        } `}
    >
      <div
        className={`flex flex-grow   flex-col items-center justify-center p-6 space-y-6 h-full w-full sm:w-1/2  ${themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#ffffff]"
          }`}
      >
        <div className="flex justify-between  flex-wrap w-full ">
          <div className="flex justify-start gap-2 mr-17">
            <Button
              text="Excel template"
              onClick={() => downloadTemplate("excel")}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                  />
                </svg>
              }
              type="button"
               className="px-1"
            />
            <Button
              text="Csv template"
              onClick={() => downloadTemplate("csv")}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                  />
                </svg>
              }
              className="px-1"
              type="button"
            />
          </div>
          {newUsers.length > 0 && (
            <div>
              <a
                onClick={() => setShowTable(!showTable)}
                className={`
               flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  bg-gray-500 hover:bg-gray-400 text-[#FFFFFF] text-[12px] leading-[15px] mb-0 mt-2 font-normal cursor-pointer group inline-flex items-center  py-2 pl-2 pr-2 text-sm font-medium min-w-[4.5rem] max-w-[4.9rem]"`}
              >
                {/* {tab.icon} */}
                {showTable ? "Hide" : "Show"} Table
              </a>
            </div>
          )}
        </div>
        <div className=" flex flex-col w-full md:w-full sm:w-full md:h-1/2 min-h-0 bg-transparent opacity-100 origin-center">
          {!showTable && (
            <div className=" antialiased box-border text-[#333] font-sans leading-none  text-left">
              <div
                className={` w-full h-full border border-solid border-1px   rounded max-h-full max-w-full outline-none  p-2 ${themeMode === "dark"
                    ? "bg-gray-800 rounded-lg shadow-md border-white-09"
                    : " bg[#f4f4f4] border-black-09"
                  }`}
              >
                <label
                  htmlFor="dropzone-file2"
                  className={`flex flex-col items-center justify-center  h-full border border-1px  border-dashed  rounded-lg  overflow-hidden flex flex-col items-center space-y-4  ${themeMode === "dark"
                      ? "bg-gray-900 border border-gray-700 rounded-lg  hover:bg-[rgba(222,_222,_240,_0.1)] border-white-09 "
                      : " hover:bg-[#eaeaea] border-black-09"
                    } rounded-[0.25rem] px-4 pb-12 pt-5  sm:px-6 sm:pt-6 sm:w-full md:w-full cursor-pointer  `}
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p
                      className={`mb-2 text-sm ${themeMode === "dark" ? "text-gray-400" : "text-gray-400"
                        } `}
                    >
                      <span className="font-semibold">Click to upload </span> or
                      drag and drop
                    </p>
                    <p
                      className={`text-xs  ${themeMode === "dark" ? "text-gray-400" : "text-gray-400"
                        } `}
                    >
                      Excel files (.xls, .xlsx)
                    </p>
                  </div>
                  <input
                    id="dropzone-file2"
                    type="file"
                    className="hidden"
                    onChange={(e) => handleFileChange(e)}
                    accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                </label>
              </div>
            </div>
          )}
          {newUsers.length > 0 && showTable && (
            <div className="overflow-x-auto overflow-y-auto max-h-[400px] flex-1 ">
              <table
                className={`min-w-full border border-b border-solid border-[1px]  table-fixed  ${themeMode === "dark"
                    ? " bg-[#1C1C29] border-white-06"
                    : "bg-[#efeff2] border-black-06"
                  }`}
              >
                <thead
                  className={`border border-b border-t-0 border-r-0 border-l-0 border-solid border-[1px] px-8 ${themeMode === "dark"
                      ? "bg-[#1C1C29] border-white-06"
                      : "bg-[#efeff2] border-black-06"
                    }`}
                >
                  <tr className="">
                    <th
                      onClick={() => handleSort("name")}
                      className={`h-12 w-1/5 p-2.5 pl-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light ${themeMode === "dark"
                          ? "text-white text-opacity-60"
                          : "text-gray-600"
                        }`}
                    >
                      <div className="flex justify-start gap-2">
                        Name{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                          />
                        </svg>
                      </div>
                    </th>
                    <th
                      onClick={() => handleSort("email")}
                      className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-left uppercase custom-shadow-light w-1/5 ${themeMode === "dark"
                          ? "text-white text-opacity-60"
                          : "text-gray-600"
                        }`}
                    >
                      <div className="flex justify-start gap-2">
                        Email
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                          />
                        </svg>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${themeMode === "dark" ? "bg-[#21212F]" : "bg-[#f4f4f6]"
                    }`}
                >
                  {sortedData.length > 0 ? (sortedData.map((row, index) => (
                    <tr
                      key={row.email || `fallback-key-${index}`}
                      className={` h-13 border-b  ${themeMode === "dark"
                          ? "text-[#FFF] hover:bg-[#282834] border-[rgba(255,255,255,0.06)]"
                          : "hover:bg-[#E8E8E9] border-[rgba(0,0,0,0.06)]"
                        }`}
                    >
                      <td className="p-2.5 pl-12 text-left text-sm   ">
                        {row.first_name + " " + row.last_name}
                      </td>
                      <td className="p-2.5 pl-6 text-left text-sm   ">
                        {row.email}
                      </td>
                    </tr>
                  ))) : (
                    newUsers.map((row, index) => (
                      <tr
                        key={row.email || `fallback-key-${index}`}
                        className={` h-13 border-b  ${themeMode === "dark"
                            ? "text-[#FFF] hover:bg-[#282834] border-[rgba(255,255,255,0.06)]"
                            : "hover:bg-[#E8E8E9] border-[rgba(0,0,0,0.06)]"
                          }`}
                      >
                        <td className="p-2.5 pl-12 text-left text-sm   ">
                          {row.first_name + " " + row.last_name}
                        </td>
                        <td className="p-2.5 pl-6 text-left text-sm   ">
                          {row.email}
                        </td>
                      </tr>
                    )))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="flex justify-start gap-20 flex-wrap w-full hidden">
          <div className="flex w-1/2 justify-start gap-2 mr-17 mt-8">
            <a
              className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  bg-[#205dc2] hover:bg-[#3575DE] text-[#FFFFFF] group inline-flex items-center  py-2 pl-2 pr-2 text-sm font-medium min-w-[4.5rem] max-w-[4.9rem] cursor-pointer `}
            >
              {/* {tab.icon} */}
              Save
            </a>
          </div>
        </div>
      </div>
      {/* Drawer */}
      <Dialog
        open={fileUploadInfoMenu}
        onClose={setFileUploadInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.8rem]">
          <div className=" absolute flex min-h-full max-w-full min-w-[15%] items-end justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    {success && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        <span>Survey updated</span>
                      </div>
                    )}
                    {error && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                        <span>Survey couldn't update</span>
                      </div>
                    )}
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setFileUploadInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
